import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import './tooltip.scss';
import ReactHtmlParser from 'react-html-parser';

const TooltipBody = forwardRef(
  (
    {
      leftPosition,
      topPosition,
      direction,
      content,
      className,
      active,
      zIndex,
    },
    ref
  ) => {
    return content
      ? ReactDOM.createPortal(
          <span
            className={`tooltip-tip ${direction || 'bottom'} ${
              active ? 'show' : ''
            }`}
            ref={ref}
            style={{ left: leftPosition, top: topPosition, zIndex }}
          >
            <span className={`tooltip-content ${className}`}>
              {typeof content === 'object' ? content : ReactHtmlParser(content)}
            </span>
          </span>,
          document.body
        )
      : null;
  }
);

TooltipBody.propTypes = {
  direction: PropTypes.string,
  content: PropTypes.string,
  className: PropTypes.string,
  leftPosition: PropTypes.number,
  topPosition: PropTypes.number,
  active: PropTypes.bool.isRequired,
  zIndex: PropTypes.number,
};

TooltipBody.defaultProps = {
  direction: '',
  content: '',
  className: '',
  leftPosition: 0,
  topPosition: 0,
  zIndex: 1000000,
};

export default TooltipBody;
